const menuItemFormParamFreq = {
  day: 'días',
  month: 'meses'
};

export default menuItemFormParamFreq;
